import generateUtilityClasses from '../generateUtilityClasses';
import generateUtilityClass from '../generateUtilityClass';
export function getBackdropUtilityClass(slot) {
  return generateUtilityClass('MuiBackdrop', slot);
}
const backdropUnstyledClasses = generateUtilityClasses('MuiBackdrop', ['root', 'invisible']);
export default backdropUnstyledClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/core/BackdropUnstyled/backdropUnstyledClasses.js
// module id = 1120
// module chunks = 0